import { render, staticRenderFns } from "./logisticsLink.vue?vue&type=template&id=451db720&scoped=true"
import script from "./logisticsLink.vue?vue&type=script&lang=js"
export * from "./logisticsLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451db720",
  null
  
)

export default component.exports